import compareDeepMap from './deep-map';

const compare = (value1, value2) => {

	if(
		(typeof value1 === 'object' && value1 !== null) || 
		(typeof value2 === 'object' && value2 !== null)
	){
		return compareDeepMap(value1, value2);
	}

	return value1 === value2;
}
export default compare;